import React, { useRef, useContext } from "react";
import { PostPurchaseContext } from "../../context/PostPurchaseContext";
import FormCheckbox from "../FormCheckbox";
import FormTextInput from "../FormTextInput";
import NextButton from "../NextButton";

function Step1() {
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneNumberRef = useRef(null);

  const requiredInputRefs = [
    firstNameRef,
    lastNameRef,
    emailRef,
    phoneNumberRef,
  ];

  return (
    <div className="flex flex-col items-start text-start gap-6 py-8">
      <div className="flex gap-3 w-full">
        <FormTextInput
          errorMessage="Enter your first name"
          ref={firstNameRef}
          label="First Name"
          srOnlyLabel={"First"}
          name="firstName"
          extraClasses="before:top-[38%]"
        />
        <FormTextInput
          errorMessage="Enter your last name."
          ref={lastNameRef}
          label="Last Name"
          name="lastName"
          extraClasses="before:top-[38%]"
        />
      </div>

      <div className="flex flex-col gap-3 w-full">
        <FormTextInput
          errorMessage="Enter your email."
          ref={emailRef}
          label="Email"
          name="email"
          extraClasses="before:top-[38%]"
        />
        <FormCheckbox
          label="Sign me up for email notifications"
          name="emailNotifications"
        /> 
      </div>
      
      <div className="flex flex-col gap-3 w-full">
        <FormTextInput
          errorMessage="Enter your phoner number."
          ref={phoneNumberRef}
          label="Phone"
          name="phoneNumber"
          extraClasses="before:top-[38%]"
        />
          <FormCheckbox
          label="Sign me up for SMS notifications"
          name="smsNotifications"
        />
      </div>
      <NextButton requiredInputRefs={requiredInputRefs} isLoading={false} />
    </div>
  );
}

export default Step1;
